module.exports = __webpack_public_path__ + "src/assets/games/42/262.jpg";